<div class="avatar items-start" *ngIf="(logo$ | ngrxPush)?.loading">
    <div class="spinner spinner-primary {{ avatarClasses }}"></div>
</div>

<div class="avatar items-start" *ngIf="(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
    <div class="{{ avatarClasses }} rounded-lg">
        <img [src]="(logo$ | ngrxPush)?.url" class="!object-contain" />
    </div>
</div>

<div class="avatar placeholder items-start" *ngIf="!(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
    <div class="{{ avatarClasses }} rounded-lg bg-neutral text-neutral-content">
        <span class="uppercase">{{ initials$ | ngrxPush }}</span>
    </div>
</div>
